export type BallotActionKind = 'fullProfile' | 'compare' | 'explain';

export interface PendingBallotAction {
  kind: BallotActionKind;
  id: string;
}

export function getBallotActionState({
  kind,
  id,
  pendingAction,
  isProcessing,
}: {
  kind: BallotActionKind;
  id: string;
  pendingAction: PendingBallotAction | null;
  isProcessing: boolean;
}) {
  const isThisActionPending = pendingAction?.kind === kind && pendingAction.id === id;

  return {
    isThisActionPending,
    isDisabled: (isProcessing || !!pendingAction) && !isThisActionPending,
  };
}
